import { Switch, Route } from "react-router-dom";
import routes from "./URL";
import ReviewScreen from "../screens/SettingScreens/ReviewScreen";

export default function FeedbackRoutes() {
  return (
    <Switch>
      <Route
        exact
        path={routes.admin.review.root(":hotelSlug")}
        component={ReviewScreen}
      />
    </Switch>
  );
}